// extracted by mini-css-extract-plugin
export var actionButton = "_8v-1";
export var actionButtons = "_8v-2";
export var actions = "_8v-0";
export var aiUnread = "_8v-10";
export var alignCenter = "_8v-h";
export var backWrapper = "_8v-3";
export var cellContainer = "_8v-4";
export var checkboxContainer = "_8v-5";
export var contentContainer = "_8v-6";
export var contentHeader = "_8v-8";
export var conversationsTableWrapper = "_8v-s";
export var draftReplyBadgeContainer = "_8v-m";
export var dropdownItem = "_8v-b";
export var dropdownItemsContainer = "_8v-a";
export var dropdownTitle = "_8v-c";
export var errorIcon = "_8v-7";
export var filter = "_8v-d";
export var gray = "_8v-i";
export var headerActionButtons = "_8v-e";
export var headerCheckboxContainer = "_8v-f";
export var icon = "_8v-j";
export var menuContainer = "_8v-k";
export var noMoreTicketsIcon = "_8v-12";
export var noMoreTicketsSubText = "_8v-13";
export var oneLine = "_8v-l";
export var optionsButton = "_8v-n";
export var plus = "_8v-o";
export var portalButtonsWrapper = "_8v-g";
export var red = "_8v-p";
export var scrolledTop = "_8v-9";
export var search = "_8v-q";
export var selectedConversationsCount = "_8v-r";
export var spinner = "_8v-t";
export var strong = "_8v-u";
export var summaryCell = "_8v-v";
export var tableContainer = "_8v-11";
export var tagContainer = "_8v-w";
export var threeDots = "_8v-x";
export var twoLines = "_8v-y";
export var unread = "_8v-z";